import { fetch } from '@utils/utils';
import * as T from '@modules/hr-workPositions/_workPositionsTypes';

export const getWorkPosition = ({ addError }) => async (id: string): Promise<T.WorkPosition> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/work-positions/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.WorkPosition = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/hr-workPositions/_workPositionsActions.ts